var _objectSpread = require("E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
var _objectWithoutProperties = require("E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/objectWithoutProperties.js").default;
var _excluded = ["class", "staticClass", "style", "staticStyle", "attrs"];
require("core-js/modules/es.array.concat.js");
module.exports = {
  functional: true,
  render: function render(_h, _vm) {
    var _c = _vm._c,
      _v = _vm._v,
      data = _vm.data,
      _vm$children = _vm.children,
      children = _vm$children === void 0 ? [] : _vm$children;
    var classNames = data.class,
      staticClass = data.staticClass,
      style = data.style,
      staticStyle = data.staticStyle,
      _data$attrs = data.attrs,
      attrs = _data$attrs === void 0 ? {} : _data$attrs,
      rest = _objectWithoutProperties(data, _excluded);
    return _c('svg', _objectSpread({
      class: ["icon", classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 1024 1024",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "200",
        "height": "200"
      }, attrs)
    }, rest), children.concat([_c('defs'), _c('path', {
      attrs: {
        "d": "M215.04 872.96c-15.36 0-25.6-12.8-25.6-25.6v-64c0-64 20.48-125.44 56.32-176.64 35.84-51.2 84.48-89.6 143.36-112.64l10.24-2.56-7.68-5.12C345.6 450.56 320 396.8 320 340.48c0-102.4 84.48-186.88 186.88-186.88s186.88 84.48 186.88 186.88c0 56.32-25.6 110.08-71.68 145.92l-7.68 5.12 10.24 2.56c58.88 23.04 107.52 61.44 143.36 112.64 35.84 51.2 56.32 112.64 56.32 176.64v64c0 15.36-12.8 25.6-25.6 25.6H215.04zm289.28-350.72c-145.92 0-263.68 117.76-263.68 261.12v38.4H768v-38.4C768 640 650.24 522.24 504.32 522.24zm0-320c-74.24 0-135.68 58.88-135.68 133.12 0 74.24 61.44 133.12 135.68 133.12S640 409.6 640 335.36s-61.44-133.12-135.68-133.12zm-417.28 576c-15.36 0-25.6-12.8-25.6-25.6V704c0-94.72 51.2-179.2 135.68-220.16l7.68-2.56-5.12-5.12c-25.6-28.16-40.96-64-40.96-102.4 0-84.48 69.12-151.04 151.04-153.6 0 0 0 2.56-2.56 2.56-12.8 17.92-23.04 35.84-30.72 56.32-40.96 15.36-69.12 51.2-69.12 94.72 0 40.96 23.04 76.8 58.88 92.16 10.24 5.12 17.92 12.8 17.92 23.04s-7.68 20.48-17.92 25.6l-2.56-2.56c-87.04 23.04-151.04 99.84-151.04 192v23.04h30.72c-2.56 17.92-5.12 35.84-5.12 51.2h-51.2zm783.36 0c0-17.92-2.56-35.84-5.12-51.2H896V704c0-89.6-61.44-168.96-151.04-192l-5.12-2.56c-10.24-5.12-17.92-12.8-17.92-25.6 0-10.24 7.68-20.48 17.92-23.04 35.84-15.36 58.88-53.76 58.88-92.16 0-43.52-28.16-81.92-69.12-94.72-7.68-20.48-17.92-38.4-30.72-56.32 0 0 0-2.56-2.56-2.56 84.48 2.56 151.04 69.12 151.04 153.6 0 38.4-15.36 74.24-40.96 102.4l-5.12 5.12 7.68 2.56c84.48 43.52 135.68 128 135.68 220.16v48.64c0 15.36-12.8 25.6-25.6 25.6H870.4zm0 0"
      }
    })]));
  }
};